import {
  NotesIcon,
  BusinessChartIcon,
  CalculatorIcon,
  BookOpenedIcon,
} from 'shared/ui/Icons'
import { Routes } from '../../../config/routes'

const menuItems = {
  PROPOSALS: {
    name: 'Propostas',
    id: 'propostas',
    icon: NotesIcon,
    link: `${Routes.Home}`,
  },
  SIMULATE_CREDIT: {
    name: 'Simulação',
    id: 'simulacao',
    icon: CalculatorIcon,
    link: `${Routes.Simulator}`,
  },
}

const flagMenuItems = {
  DASHBOARD_AUTONOMOUS: {
    name: 'Dashboard de performance',
    id: 'dashboard-autonomous',
    icon: BusinessChartIcon,
    link: `${Routes.DashboardAutonomous}`,
  },
}

const menuSize = {
  EXPANDED: '276',
  NOT_EXPANDED: '94',
}

export { menuSize, menuItems, flagMenuItems }
